/**
 * Kullanım Koşulları — resmi metin.
 *
 * Metin güncellenirse `TERMS_VERSION` artırılır ve register anında yeni
 * sürüm kullanıcı dokümanına yazılır.
 */
export const TERMS_VERSION = "1.0";
export const TERMS_BODY = `Kullanım Koşulları

Penz hizmetinin kullanımına ilişkin temel koşullar.

İşbu Kullanım Koşulları, SALT YAZILIM TİCARET ANONİM ŞİRKETİ (“Salt Yazılım”) tarafından sunulan Penz yazılımı ve penzapp.com üzerinden sunulan hizmetlerin kullanım şartlarını düzenler. Penz’e kayıt olarak veya hizmetleri kullanarak bu koşulları kabul etmiş sayılırsınız.

1. Hizmetin Kapsamı

Penz; işletmelerin ve bağımsız profesyonellerin müşteri, tedarikçi, iş/proje, satın alma, tahsilat, ödeme, gider, kasa, raporlama ve benzeri operasyonel verilerini takip etmelerine yardımcı olmak amacıyla sunulan bulut tabanlı bir yazılım hizmetidir. Özellikler zaman içerisinde geliştirilebilir, değiştirilebilir veya yeni özellikler eklenebilir.

2. Hesap Oluşturma ve Güvenliği

Kullanıcı kayıt sırasında doğru ve güncel bilgiler vermeyi, hesap bilgilerini güncel tutmayı ve kullanıcı adı/şifresinin güvenliğini sağlamayı kabul eder. Yetkisiz kullanım şüphesi halinde Penz’e gecikmeden bildirim yapılmalıdır.

3. Kullanıcı Verileri ve Sorumluluğu

Penz içerisine kullanıcı tarafından girilen müşteri, tedarikçi, iş, proje, gelir, gider, tahsilat, ödeme ve diğer içeriklerin doğruluğu ve hukuka uygunluğu kullanıcıya aittir. Kullanıcı, sisteme girdiği verileri toplamak ve işlemek için gerekli hukuki yetkiye sahip olduğunu kabul eder. Penz, kullanıcı tarafından sisteme girilen ticari verilerin sahibi değildir.

4. Yasaklı Kullanımlar

Penz; hukuka aykırı faaliyetlerde bulunmak, üçüncü kişilerin haklarını ihlal etmek, yetkisiz veri toplamak, sisteme zarar vermek, güvenlik mekanizmalarını aşmak, başka hesap veya verilere yetkisiz erişmek ya da hizmetin çalışmasını engelleyecek faaliyetlerde bulunmak amacıyla kullanılamaz. Bu tür durumlarda hesap geçici olarak kısıtlanabilir veya sonlandırılabilir.

5. Abonelik ve Ücretlendirme

Penz’in bazı veya tüm özellikleri ücretli abonelik kapsamında sunulabilir. Güncel paketler, fiyatlar, dönemler ve varsa kampanyalar Penz internet sitesi veya uygulaması üzerinde belirtilir. Kullanıcı ücretli abonelik satın aldığında seçtiği plana ilişkin ücretin tahsil edilmesini kabul eder.

6. Ücret ve Abonelik Planı Değişiklikleri

Penz, sunulan abonelik planlarının kapsamını, özelliklerini ve ücretlerini zaman zaman değiştirme hakkını saklı tutar. Mevcut aboneleri etkileyen ücret veya abonelik planı değişiklikleri, yürürlüğe girmeden en az 30 (otuz) gün önce kullanıcıya bildirilecektir.

Ücret değişiklikleri, kullanıcının hâlihazırda ödemesi yapılmış olan mevcut abonelik dönemini etkilemez ve mevcut dönem sonuna kadar ek ücret talep edilmez. Yeni ücret veya plan koşulları, aboneliğin bir sonraki yenileme döneminden itibaren geçerli olur.

Kullanıcının yeni ücret veya abonelik koşullarını kabul etmemesi halinde, değişiklik yürürlüğe girmeden önce aboneliğinin yenilenmemesini talep etme hakkı bulunmaktadır. Bu durumda abonelik, ödemesi yapılmış mevcut abonelik döneminin sonuna kadar devam eder ve dönem sonunda sona erer.

Yıllık aboneliklerde, abonelik dönemi başladıktan sonra yapılan iptal veya yenilememe talepleri mevcut yıllık abonelik dönemini sona erdirmez ve kullanılmayan süreye ilişkin ücret iadesi yapılmaz. Kullanıcı, mevcut yıllık abonelik süresinin sonuna kadar Penz hizmetlerinden yararlanmaya devam edebilir.

7. Aboneliğin Yenilenmesi ve İptali

Aylık veya yıllık abonelikler, satın alma sırasında belirtilen koşullara göre yenilenebilir. Kullanıcı, sunulan abonelik yönetim araçları veya Penz iletişim kanalları üzerinden aboneliğinin yenilenmesini iptal edebilir.

İptal işlemi, kullanıcının mevcut ve ücreti ödenmiş abonelik dönemini sona erdirmez; yalnızca takip eden dönemde aboneliğin yenilenmesini engeller. Kullanıcı, mevcut abonelik süresinin sonuna kadar Penz hizmetlerinden yararlanmaya devam edebilir.

Yıllık aboneliklerde, abonelik dönemi başladıktan sonra kullanıcının erken iptal talebinde bulunması halinde mevcut yıllık abonelik sona erdirilmez ve kullanılmayan aylara ilişkin kısmi veya tam ücret iadesi yapılmaz. Abonelik, ödenmiş yıllık dönemin sonuna kadar aktif kalır ve iptal talebi takip eden yıllık dönemin yenilenmemesi şeklinde uygulanır.

Kanunen kullanıcıya tanınması zorunlu olan cayma, iade ve diğer tüketici hakları saklıdır.

8. Ödeme İşlemleri

Ödeme işlemleri yetkili ödeme hizmeti sağlayıcıları üzerinden gerçekleştirilebilir. Ödeme kuruluşunun talep ettiği kart ve ödeme bilgilerinin işlenmesi ilgili kuruluşun güvenli altyapısında gerçekleştirilebilir. Ödeme altyapısının teknik ve operasyonel kuralları ilgili hizmet sağlayıcının şartlarına da tabi olabilir.

9. İade ve Ödeme İtirazları

Abonelik ücretlerine ilişkin iade talepleri yürürlükteki mevzuat, hizmetin niteliği ve işbu Kullanım Koşulları kapsamında değerlendirilir.

Yıllık abonelik ücretleri, yıllık abonelik dönemi başladıktan sonra kullanıcının kendi isteğiyle aboneliğini erken iptal etmesi nedeniyle kısmen veya tamamen iade edilmez. Kullanılmayan aylar için ücret iadesi, mahsup veya oransal geri ödeme yapılmaz; kullanıcı ödenmiş yıllık abonelik döneminin sonuna kadar Penz hizmetini kullanmaya devam edebilir.

Teknik hata nedeniyle mükerrer, hatalı veya yetkisiz bir tahsilat gerçekleştiğinin tespit edilmesi halinde kullanıcı Penz ile iletişime geçebilir ve ilgili işlem ayrıca değerlendirilir.

Yürürlükteki mevzuat uyarınca kullanıcıya tanınması zorunlu olan cayma, iade ve diğer tüketici hakları saklıdır.

10. Hizmetin Kullanılabilirliği

Penz’in kesintisiz ve hatasız çalışması için makul teknik önlemler alınır. Ancak bakım, güncelleme, internet veya altyapı sağlayıcısı kesintileri, üçüncü taraf hizmetleri, siber saldırılar, mücbir sebepler veya Salt Yazılım’ın makul kontrolü dışındaki nedenlerle geçici kesintiler meydana gelebilir.

11. Veri Güvenliği

Salt Yazılım, Penz üzerinde işlenen verilerin güvenliğini sağlamak amacıyla makul teknik ve idari tedbirler uygular. Kullanıcı kendi hesap ve erişim bilgilerinin güvenliğinden sorumludur. İnternet tabanlı hiçbir sistem için mutlak güvenlik garantisi verilemez.

12. Finansal ve Muhasebesel Sorumluluk

Penz bir mali müşavirlik, muhasebe, hukuk veya finansal danışmanlık hizmeti değildir. Penz üzerindeki rapor ve hesaplamalar kullanıcının sisteme girdiği verilere dayanır. Bu bilgilerin resmi muhasebe kayıtları, vergi beyannameleri veya yasal finansal belgeler yerine kullanılması konusunda nihai sorumluluk kullanıcıya aittir.

13. Fikri Mülkiyet

Penz yazılımı, marka, logo, kullanıcı arayüzü, tasarım, metinler ve diğer içeriklere ilişkin fikri mülkiyet hakları Salt Yazılım’a veya ilgili hak sahiplerine aittir. Yazılımın izinsiz kopyalanması, çoğaltılması, tersine mühendislik yapılması, kaynak kodunun elde edilmeye çalışılması, satılması veya lisanslanması yasaktır.

14. Hesabın Askıya Alınması veya Sonlandırılması

Kullanım Koşulları’nın ciddi şekilde ihlal edilmesi, sistem güvenliğinin tehdit edilmesi, hukuka aykırı kullanım veya ödeme yükümlülüklerinin yerine getirilmemesi durumunda ilgili hesap veya belirli hizmetlere erişim geçici olarak kısıtlanabilir ya da gerekli hallerde sonlandırılabilir.

15. Hesabın Kapatılması ve Veriler

Kullanıcı hesabının kapatılmasını talep edebilir. Hesap kapatıldıktan sonra veriler, yürürlükteki mevzuattan doğan saklama yükümlülükleri saklı kalmak kaydıyla veri saklama ve imha süreçlerine uygun şekilde silinebilir, yok edilebilir veya anonim hale getirilebilir.

16. Sorumluluğun Sınırlandırılması

Penz, kullanıcının sisteme girdiği hatalı veya eksik verilerden doğan sonuçlardan sorumlu tutulamaz. Penz üzerinden elde edilen rapor ve bilgiler doğrultusunda alınan ticari, mali veya operasyonel kararların sorumluluğu kullanıcıya aittir. Salt Yazılım’ın yürürlükteki mevzuat uyarınca sınırlandırılması mümkün olmayan sorumlulukları saklıdır.

17. Koşulların Değiştirilmesi

Salt Yazılım; mevzuat değişiklikleri, hizmet geliştirmeleri veya operasyonel gereklilikler doğrultusunda Kullanım Koşulları’nı güncelleyebilir. Önemli değişiklikler uygun iletişim kanalları üzerinden duyurulabilir. Güncel koşullar yayımlandığı tarihten itibaren geçerli olur.

18. Uygulanacak Hukuk

İşbu Kullanım Koşulları Türkiye Cumhuriyeti hukukuna tabidir. Tüketici sıfatını taşıyan kullanıcıların yürürlükteki tüketici mevzuatından kaynaklanan zorunlu başvuru ve yetki hakları saklıdır.

19. İletişim

SALT YAZILIM TİCARET ANONİM ŞİRKETİ
Adalet Mah. Manas Bulvarı No:47/B K:26 D:2601 Folkart Towers A Kule Bayraklı, İzmir – Türkiye
Web: penzapp.com
E-posta: hello@penzapp.com
`;
